import { useScrollReveal } from "@/hooks/useScrollReveal";
import HeroSection from "./components/HeroSection";
import StickyNavSection from "./components/StickyNavSection";
import ServiceOverviewSection from "./components/ServiceOverviewSection";
import ChallengesSection from "./components/ChallengesSection";
import AboutSection from "./components/AboutSection";
import MonthlyServiceSection from "./components/MonthlyServiceSection";
import SupportCycleSection from "./components/SupportCycleSection";
import FirstThreeMonthsSection from "./components/FirstThreeMonthsSection";
import ExamplesSection from "./components/ExamplesSection";
import DeliverablesSection from "./components/DeliverablesSection";
import ScopeSection from "./components/ScopeSection";
import PricingSection from "./components/PricingSection";
import WhoItIsForSection from "./components/WhoItIsForSection";
import FAQSection from "./components/FAQSection";
import RelatedServicesSection from "./components/RelatedServicesSection";
import CTASection from "./components/CTASection";

export default function AiOfficePage() {
  useScrollReveal();

  return (
    <>
      <HeroSection />
      <StickyNavSection />
      <ServiceOverviewSection />
      <ChallengesSection />
      <AboutSection />
      <MonthlyServiceSection />
      <SupportCycleSection />
      <FirstThreeMonthsSection />
      <ExamplesSection />
      <DeliverablesSection />
      <ScopeSection />
      <PricingSection />
      <WhoItIsForSection />
      <FAQSection />
      <RelatedServicesSection />
      <CTASection />
    </>
  );
}